export const REDIRECT_TO_TRADING_HISTORY = 'REDIRECT_TO_TRADING_HISTORY';
export const ACTIVATE_CHECK_ELIGIBILITY_PAGE =
    'ACTIVATE_CHECK_ELIGIBILITY_PAGE';
export const REDIRECT_TO_PERSONAL_INFORMATION =
    'REDIRECT_TO_PERSONAL_INFORMATION';
